module.exports = __webpack_public_path__ + "static/media/dir_wind.130e95ec.svg";